<template>
  <div :class="$style.wrapper" :style="{ overflow: !dialogType ? 'auto' : 'hidden' }">
    <div :class="$style.content">
      <div style="height: 0.1px"></div>
      <div :class="$style.sidebtns">
        <button :class="$style['concat-btn']" @click="handleConcat"></button>
        <button :class="$style['rules-btn']" @click="handleRules"></button>
      </div>
      <section :class="$style.tabs">
        <div
          v-for="item of tabs"
          :key="item.id"
          :style="{
            backgroundImage: justifyBgImage(item),
          }"
          @click="handleDateChange(item)"
        >
          <img :src="justifyDateImage(item)" />
          <img
            v-if="item.isOverDue"
            :src="`${$cdnUrl}/seckill/main/top/huodong_yijieshu.png`"
            :class="$style.over"
          />
        </div>
      </section>
      <section :class="$style.account">
        <p v-if="isBindAccount" :class="$style.bind">{{ `欢迎您，${gameAccount}` }}</p>
        <p v-else :class="$style.bind">您还未<span @click="handleBindAccount">绑定账号</span></p>
        <p :class="$style.tips">抢夺成功后，代金券直接发放到该账户</p>
        <p v-if="isBindAccount" :class="$style['change-bind']" @click="handleBindAccount">
          换绑账号
        </p>
      </section>
      <DailyTask
        :class="$style.part"
        :isFirstPay="isFirstPay"
        :isBindAccount="isBindAccount"
        :isActStart="isActStart"
        :selectDate="selectDate"
        :nowTimesTamp="nowTimesTamp"
        @handleSnatch="handleSnatch"
      />
      <SnatchVoucher
        ref="voucher"
        :class="$style.part"
        :currentVoucherList="currentVoucherList"
        :isFirstPay="isFirstPay"
        :isBindAccount="isBindAccount"
        :isLastDay="isLastDay"
        :isActStart="isActStart"
        :selectDate="selectDate"
        :nowTimesTamp="nowTimesTamp"
        :snapUpArrProp="snapUpArrProp"
        :isActEnd="isActEnd"
      />
      <GiftPacking
        :class="$style.part"
        :isActStart="isActStart"
        @seckillPointReport="seckillPointReport"
        @getSeckillGiftList="getSeckillGiftList"
      />
    </div>
    <Dialogs
      :dialogType="dialogType"
      :isBindAccount="isBindAccount"
      :ownerGameList="ownerGameList"
      :gameRecommendList="gameRecommendList"
      :isLastDay="isLastDay"
      :isThirdDay="isThirdDay"
      @getSeckillUserInfo="getSeckillUserInfo"
      @handleConcat="handleConcat"
    />
  </div>
</template>

<script>
import DailyTask from './components/seckill/DailyTask';
import SnatchVoucher from './components/seckill/SnatchVoucher';
import GiftPacking from './components/seckill/GiftPacking';
import Dialogs from './components/seckill/Dialogs';
import { Toast } from 'vant';
import dayjs from 'dayjs';
import { seckillGetVoucher, seckillUserInfo, forumBindAccount, seckillGiftList, seckillPointReport } from '@/api/activity.js';
import { mapState, mapMutations, mapActions } from 'vuex';
import { channelType } from '@/config/index.js';
import { wxShareData } from '@/utils/wxinit';
export default {
  components: {
    DailyTask,
    SnatchVoucher,
    GiftPacking,
    Dialogs,
  },
  data() {
    return {
      isActStart: true, // 活动是否开始
      isActEnd: false, // 活动是否结束
      selectDate: '', // 当前选中的日期
      dialogType: '', // 弹窗类型
      snatchState: '', // 抢夺状态
      voucherList: [], // 所有代金券列表
      currentVoucherList: [], // 当天代金券列表
      isBindAccount: false, // 用户是否绑定账号
      gameAccount: '', // 秒杀活动游戏账号
      orderDateArr: [], // 充值日期
      isFirstPay: false, // 当天是否完成首充
      tabs: [],
      lastDateStartTime: '', // 最后一天，手办抢夺开始时间
      ownerGameList: [], // 礼包列表
      gameRecommendList: [], // 推荐轮播列表
      $53code: '',
      nowTimesTamp: '', // 获取服务器当前时间戳（毫秒）
      timer: null, //计时器
      snapUpArrProp: []
    };
  },
  computed: {
    // 获取平台用户信息
    ...mapState("account", {
      userInfo: state => state.userInfo // 当前用户信息
    }),
    // 获取论坛游戏账号
    ...mapState("activity", {
      forumAccount: state => state.forumAccount
    }),
    // 活动id
    activityId() {
      return Number(this.$route.query.activity_id)
    },
    // 判断是否是最后一天
    isLastDay() {
      const lastDate = this.tabs.length && this.tabs[3].date
      return this.selectDate == lastDate ? true : false
    },
    // 判断是否是第三天
    isThirdDay() {
      const thirdDay = this.tabs.length && this.tabs[2].date
      return this.selectDate == thirdDay ? true : false
    },
  },
  watch: {
    selectDate(newValue) {
      try {
        this.currentVoucherList = this.voucherList.find(item => item.date == newValue) ? this.voucherList.find(item => item.date == newValue).info : []
        this.isFirstPay = this.orderDateArr.includes(this.selectDate)
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.dialogType = 'actOver'
    // this.getSeckillUserInfo().then(() => {
    //   this.seckillPointReport(1)
    //   this.getVoucherList()
    // })
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.nowTimesTamp) {
        this.nowTimesTamp = this.nowTimesTamp + 1000
        // console.log(dayjs(this.nowTimesTamp).format('HH:mm:ss'), 88);
      }
    }, 1000)
    this.$bus.$on('openSeckillDialog', (type) => {
      this.dialogType = type
    })
    this.$bus.$on('closeSeckillDialog', () => {
      this.dialogType = ''
    })
    wxShareData([{
      title: '代金券大回馈', // 分享朋友
      desc: '0.1折代金券，限量手办，一键带走！', // 分享描述
      link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: `${window.location.protocol}${this.$cdnUrl}/seckill/main/login/quan.png`, // 分享图标
      success: function () {
        console.log('分享朋友圈');
      }
    }, {
      title: '代金券大回馈', // 分享朋友圈
      link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: `${window.location.protocol}${this.$cdnUrl}/seckill/main/login/quan.png`, // 分享图标
      success: function () {
        console.log('分享朋友圈');
      },
    }])
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.$bus.$off('openSeckillDialog')
    this.$bus.$off('closeSeckillDialog')
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
    }),
    ...mapActions('activity', {
      getForumBindAccount: 'getForumBindAccount',
    }),
    // 获取代金券列表
    async getVoucherList() {
      const r = await seckillGetVoucher({
        lucky_draw_id: this.activityId
      })
      this.voucherList = [...r.data]
      // 保证代金券设置4天
      if (this.voucherList.length != 4) return
      this.tabs = this.voucherList.map((item, index) => {
        let imageType = ''
        switch (parseInt(index)) {
          case 0:
            imageType = '4.25'
            break;
          case 1:
            imageType = '4.26'
            break;
          case 2:
            imageType = '4.27'
            break;
          case 3:
            imageType = '4.28'
            break;
          default:
            break;
        }
        const newItem = {
          date: item.date,
          imageType: imageType,
          isOverDue: this.nowTimesTamp > dayjs(item.date).endOf('date').valueOf(),
        }
        return newItem
      })
      // 判断当前日期,默认选中当天,活动未开始时选中第一个日期，活动结束时选中最后一个日期
      if (dayjs(this.nowTimesTamp).isBefore(dayjs(this.tabs[0].date), 'date')) {
        // 活动未开始
        this.selectDate = this.tabs[0].date
        this.tabs[0].isOverDue = false
        this.isActStart = false
        this.dialogType = 'actNotStart'
      } else if (dayjs(this.nowTimesTamp).isAfter(dayjs(this.tabs[3].date), 'date')) {
        // 活动已结束,直接展示活动结束弹窗,点击确定跳转到论坛首页。
        this.selectDate = this.tabs[3].date
        this.tabs[3].isOverDue = false
        this.isActEnd = true
        this.dialogType = 'actOver'
      } else {
        this.selectDate = dayjs(this.nowTimesTamp).format('YYYY-MM-DD')
        this.isActStart = true
      }
      try {
        this.currentVoucherList = this.voucherList.find(item => item.date == this.selectDate) ? this.voucherList.find(item => item.date == this.selectDate).info : []
      } catch (error) {
        console.log(error);
      }
    },
    // 获取活动中用户信息
    async getSeckillUserInfo() {
      const r = await seckillUserInfo({
        lucky_draw_id: this.activityId
      })
      this.nowTimesTamp = r.data.current * 1000
      this.isBindAccount = r.data.is_bind == 1 ? true : false
      this.gameAccount = r.data.game_account
      this.orderDateArr = [...r.data.order]
      this.snapUpArrProp = [...r.data.snap_up]
      this.isFirstPay = this.orderDateArr.includes(this.selectDate)
    },
    // 打开礼包弹窗，获取礼包列表、推荐游戏列表
    async getSeckillGiftList() {
      this.dialogType = 'pickGift'
      this.ownerGameList = []
      this.gameRecommendList = []
      this.CHANGE_SHOW_LOADING(true)
      try {
        const r = await seckillGiftList({
          lucky_draw_id: this.activityId
        })
        this.ownerGameList = [...r.data.gift] // 礼包列表
        this.gameRecommendList = [...r.data.recommend] // 推荐轮播列表
      } catch (error) {
        console.log(error);
      } finally {
        this.CHANGE_SHOW_LOADING(false)
      }
    },
    // 埋点上报
    async seckillPointReport(type) {
      try {
        const r = await seckillPointReport({
          type,
          lucky_draw_id: this.activityId
        })
      } catch (error) {
        console.log(error);
      }
    },
    justifyBgImage(item) {
      if (item.isOverDue) {
        return `url(${this.$cdnUrl}/seckill/main/top/huodong_yijieshuanniu.png)`
      } else if (item.date === this.selectDate) {
        return `url(${this.$cdnUrl}/seckill/main/top/huodong_dangtian.png)`
      } else {
        return `url(${this.$cdnUrl}/seckill/main/top/huodong_weikaishi.png)`
      }
    },
    justifyDateImage(item) {
      if (item.isOverDue) {
        return `${this.$cdnUrl}/seckill/main/date/huodong_${item.imageType}_2.png`
      } else if (item.date === this.selectDate) {
        return `${this.$cdnUrl}/seckill/main/date/huodong_${item.imageType}_1.png`
      } else {
        return `${this.$cdnUrl}/seckill/main/date/huodong_${item.imageType}_3.png`
      }
    },
    // 53客服拉起代码
    insert53code(userId, username) {
      if (this.$53code) return
      const channel = channelType
      this.$53code = document.createElement('script');
      let src_base = '//tb.53kf.com/code/code/7218fcbe99ccc9c959f32b5afc7eb38e4/10';
      let src = `${src_base}?u_cust_id=${channel}_${userId}&u_cust_name=秒杀活动_${username}`;
      this.$53code.src = src;
      this.$53code.async = 'async';
      // 53kf横屏图标太大兼容处理
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(this.$53code, s);
    },
    // 点击联系客服
    handleConcat() {
      this.seckillPointReport(2)
      this.CHANGE_SHOW_LOADING(true)
      this.insert53code(this.userInfo.id, this.userInfo.wechat_name)
      setTimeout(() => {
        const api = window.$53.createApi();
        if (!api) return
        api.push('cmd', 'mtalk');
        api.query();
        this.CHANGE_SHOW_LOADING(false)
      }, 500);
    },
    handleRules() {
      this.seckillPointReport(4)
      this.$router.push({ name: "activity.seckillRules" });
    },
    handleDateChange(item) {
      if (this.selectDate == item.date) return
      this.currentVoucherList = []
      this.selectDate = item.date
      if (item.isOverDue) {
        Toast('当天活动已结束，请关注即将开抢的场次！')
      }
    },
    // 点击开始抢券按钮
    handleSnatch() {
      this.$refs.voucher.$el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    // 换绑、绑定账户
    handleBindAccount() {
      if (!this.isActStart) {
        this.$toast('当前活动未开始，\n请于4月25日来参加哦！')
        return
      }
      this.CHANGE_SHOW_LOADING(true)
      this.getForumBindAccount().then(() => {
        this.CHANGE_SHOW_LOADING(false)
        if (!this.isBindAccount && this.forumAccount) {
          this.dialogType = 'gameAccountTips'
        } else {
          this.dialogType = 'showBindAccount'
        }
      })
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable';
@import '~@/styles/mixins.scss';
.wrapper {
  width: 100vw;
  height: 100vh;
  .content {
    position: relative;
    width: 100vw;
    height: 1119px;
    background-image: url('#{$cdn-url-hm}/seckill/main/date/huodong_banner_new.png'),
      url('#{$cdn-url-hm}/seckill/main/background/bg_02.png'),
      url('#{$cdn-url-hm}/seckill/main/background/bg_03.png'),
      url('#{$cdn-url-hm}/seckill/main/background/bg_04.png'),
      url('#{$cdn-url-hm}/seckill/main/background/bg_05.png');
    background-size: 100% auto;
    background-position: 0 0, 0 206px, 0 464px, 0 737px, 0 942px;
    background-repeat: no-repeat;
    .sidebtns {
      position: absolute;
      top: 5px;
      right: 1px;
      display: flex;
      flex-direction: column;
      .concat-btn {
        @include clearBtnDefaultStyle;
        width: 26px;
        height: 57px;
        background-image: url('#{$cdn-url-hm}/seckill/main/top/huodong_lianxikefu.png');
      }
      .rules-btn {
        @include clearBtnDefaultStyle;
        width: 26px;
        height: 57px;
        background-image: url('#{$cdn-url-hm}/seckill/main/top/huodong_huodongguize.png');
      }
    }
    .tabs {
      margin-top: 206px;
      display: flex;
      width: 100%;
      height: 48px;
      box-shadow: 1px 1px 1px #383636;
      > div {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 25%;
        background-size: contain;
        background-repeat: no-repeat;
        > img {
          width: auto;
          height: 27px;
        }
        .over {
          position: absolute;
          right: 0px;
          bottom: 0px;
        }
      }
    }
    .account {
      position: relative;
      margin-top: 20px;
      text-align: center;
      .bind {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #fff4b5;
        line-height: 23px;
        > span {
          font-weight: 600;
          color: #11ae09;
          text-decoration-line: underline;
        }
      }
      .tips {
        font-size: 10px;
        font-weight: 400;
        color: #c1b678;
        line-height: 23px;
      }
      .change-bind {
        position: absolute;
        top: 0px;
        right: 6.3px;
        font-size: 10px;
        font-weight: 400;
        text-decoration: underline;
        color: #11ae09;
        line-height: 23px;
      }
    }
    .part {
      margin-top: 17px;
    }
    .popup-rules {
      width: 100vw;
      height: 100vh;
      background: red;
    }
  }
}
</style>
